import React from 'react';
import { Input, Button, Select, Viewer, Modal, Pagination, Tooltip, DatePicker, Table } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, Colors, checkPermission } from 'utils';
import { connect } from 'react-redux';
import { EditIcon, AlertIcon, Menu as MenuIcons, TrashIcon, CleanIcon, AddIcon, RestoreIcon } from 'assets/icons';
import moment from 'moment';
import { CompanyService } from 'services';
import ModalCompanies from './modal-companies';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: ''
}

class CompanyBills extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'Nombre',
			'Acciones'
		],
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		visible: false,
		item: null
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Empresa',
				onBack: null,
				subtitle: 'Consulta y administra todas las empesa registradas en el sistema.',
				color: '#edf0fe',
				icon: MenuIcons.Menu6
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false,callback = () => {}) => {
		const res: any = await CompanyService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
		});
		this.setState({
			data: res.companies.rows,
			last_page: res.companies.count
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	add = () => {
		this.setState({
			visible: true
		});
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => this.load(true));
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	delete = async (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar la empresa?',async () => {
			await CompanyService.admin.delete({
				company_id: item?.id
			});	
			Globals.showSuccess("Se ha eliminado la empresa correctamente");
			this.load(true);
		});
	}

	render() {
		const { visible } = this.state;

		return (
			<div id="company-bills">
				<Modal
		          className="modal-companies"
		          visible={ visible }
		          title={ this.state.item != null ? 'Modificar empresa' : 'Crear empresa' }
		          onClose={ () => this.onClose() }
		        >
		          <ModalCompanies
		          	item={ this.state.item }
		            onClose={ () => this.onClose() } />
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-12">
						<div className="row">
							<div className="col-md-3">
								<Input
									value={ this.state.form.search }
									name="search"
									placeholder="Buscar"
									label="Buscar por nombre"
									className="input-table"
									onSubmit={ () => this.load() }
									onChange={ (e: any) => {
										clearTimeout(this.timer);
										this.timer = setTimeout(() => {
											this.load(true);
										},1000);
										this.change(e); 
									} } />
							</div>
							<div className="col-md-9 text-right">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ RestoreIcon } />
											<p>Limpiar</p>
										</button>
									)
								}
								{
									(checkPermission(Constants.MODULES.BILLS,'write') || checkPermission(Constants.MODULES.ADMIN_BILLS,'write')) && (
										<button className="btn add-btn" onClick={ this.add }>
											<img src={ AddIcon } />
											<p>Nuevo</p>
										</button>
									)
								}
							</div>
						</div>
					</div>
				</div>

				<Table title="Empresas" data={ this.state.data.length } header={ this.state.header }
					pagination={
						<Pagination 
							pages={ this.state.last_page } 
							active={ this.state.page }
							onChange={ async (page: number) => {
								await this.setState({
									page: page
								});
								this.load();
							} } />
					}
				>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ i.name }</td>
								<td style={{ 'whiteSpace': 'nowrap' }}>
									{
										checkPermission(Constants.MODULES.BILL_PLANS,'write') && (
											<Tooltip title="Editar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,i) }>
													<img src={ EditIcon } />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.BILL_PLANS,'delete') && (
											<Tooltip title="Eliminar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.delete(e,i) }>
													<img src={ TrashIcon } />
												</a>
											</Tooltip>
										)
									}
								</td>
							</tr>
						)
					}) }
				</Table>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(CompanyBills);